import { ActionButtonGroup } from "@/components/AppGrid/ActionButtons/ActionButtonGroup";
import { EditButton } from "@/components/AppGrid/ActionButtons/EditButton";
import { Icons } from "@/components/Icons/Icons";
import { openShareModal } from "@/components/_pages/ModelPage/Header/SharingButton";
import { financialDeckModel } from "@/models/financialDecks";
import { Route } from "@/paths";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { ActionIcon, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { generatePath } from "react-router-dom";

export const ActionRenderer = (props: CustomCellRendererProps) => {

  const entity = financialDeckModel.createEntityInstance({
    id: props.data.id,
  });

  const remove = async () => {
    await entity.remove();
  };

  return (
    <ActionButtonGroup>
      <ActionIcon
        variant={"light"}
        onClick={() => openShareModal(props.data.name || "Untitled", entity)}
      >
        <Icons.Share />
      </ActionIcon>

      <EditButton
        path={generatePath(Route.Model, { modelId: props.data.id })}
      />

      <ActionIcon
        variant={"light"}
        onClick={() => openDeleteModal(props.data.name, remove)}
      >
        <Icons.Delete />
      </ActionIcon>
    </ActionButtonGroup>
  );
};

const openDeleteModal = async (name: string, removeFn: () => void) => {
  await modals.openConfirmModal({
    title: "Delete this model?",

    children: (
      <Text size="md">
        Are you sure you want to delete the '{name || "Untitled"}' model?
      </Text>
    ),
    labels: {
      confirm: `Delete`,
      cancel: "Cancel",
    },
    confirmProps: { color: "red" },
    onConfirm: async () => {
      removeFn();
    },
  });
};
